<div *ngIf="loadMap">
  <app-map-header></app-map-header>
  <app-side-panels> </app-side-panels>
  <!-- chat component  -->
  <app-chat *ngIf="showChat && chatEnable"></app-chat>
  
  <!-- now handling below divs with ngStyle because of animation not work properly with ngIf -->

  <!-- for enplan  icon when chat is disabled -->
  <div
    [ngStyle]="{
      visibility: !infoBar && !chatEnable && !hideHeader ? 'visible' : 'hidden',
      transition:!sideNavService.showAnimateNow?'right 0.6s linear':'0s'
    }"
    [style.right.px]="rightEnplan"
    [ngClass]="state === 'open' ? 'attribution' : 'enPlan-closed'"
  >
    <a
      *ngIf="
        mapServices.elementsVisibility['enplan_logo'] && embedHide !== 'true'
      "
      class="enplan"
      (click)="openEnplan()"
      >ENPLAN</a
    >
  </div>

  <!-- for enplan  icon when chat is enabled -->
  <div
    [ngStyle]="{
      visibility: !infoBar && chatEnable && !hideHeader ? 'visible' : 'hidden',
      transition:!sideNavService.showAnimateNow?'right 0.6s linear':'0s'
    }"
    
    [ngClass]="
       state === 'open' ? 'move_left_open' : 'move_left_close'
    "
  >
    <a
      *ngIf="mapServices.elementsVisibility['enplan_logo'] && embedHide !== 'true'"
      class="enplan"
      (click)="openEnplan()"
      >ENPLAN</a
    >
    <button *ngIf="!chatImageUrl" class="chat_btn" (click)="showChatNow()">
      {{ chatBtnText }}
    </button>
    <img
      *ngIf="chatImageUrl"
      (click)="showChatNow()"
      [src]="chatImageUrl"
      width="25px;"
      class="chat_btn"
    />
  </div>

  <!-- for enplan icon when info panel is open and chat is disabled -->
  <div
    [ngStyle]="{
      visibility: infoBar && !chatEnable && !hideHeader ? 'visible' : 'hidden',
      transition:!sideNavService.showAnimateNow?'right 0.6s linear':'0s'
    }"
    [ngClass]="infoLeftState === 'open' ? 'info-panel' : 'enPlan-closed'"
  >
    <a
      *ngIf="mapServices.elementsVisibility['enplan_logo'] && embedHide !== 'true'"
      class="enplan"
      (click)="openEnplan()"
      >ENPLAN</a
    >
  </div>

  <!-- for enplan icon when info panel is open and chat is enabled -->
  <div
    [ngStyle]="{
      visibility: infoBar && chatEnable && !hideHeader ? 'visible' : 'hidden',
      transition:!sideNavService.showAnimateNow?'right 0.6s linear':'0s'
    }"
    [ngClass]="
       infoLeftState === 'open'
        ? 'move_left_open_info'
        : 'move_left_close_info'
    "
  >
    <a
      *ngIf="mapServices.elementsVisibility['enplan_logo'] && embedHide !== 'true'"
      class="enplan"
      (click)="openEnplan()"
      >ENPLAN</a
    >
    <button *ngIf="!chatImageUrl" class="chat_btn" (click)="showChatNow()">
      {{ chatBtnText }}
    </button>
    <img
      *ngIf="chatImageUrl"
      (click)="showChatNow()"
      [src]="chatImageUrl"
      width="25px;"
      class="chat_btn"
    />
  </div>
 
</div>
